import moment from "moment";
import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { ReactQueryConfigProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query-devtools';
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { default as UploadPresentation } from "./components/UploadPresentation";
import { default as UploadVideo } from "./components/UploadVideo";
import Associations from "./containers/new/associations";
import AssociationForm from "./containers/new/associations/form";
import Contact from "./containers/new/contact";
import Events from "./containers/new/events";
import AddEvent from "./containers/new/events/form";
import Presentations from "./containers/new/presentations";
import AddEditPresentation from "./containers/new/presentations/form";
import Rooms from "./containers/new/rooms";
import AddRoom from "./containers/new/rooms/form";
import Sessions from "./containers/new/sessions";
import SessionForm from "./containers/new/sessions/form";
import Speakers from "./containers/new/speakers";
import AddSpeaker from "./containers/new/speakers/form";
import Themes from "./containers/new/themes";
import ThemeForm from "./containers/new/themes/form";
import Types from "./containers/new/types";
import TypeForm from "./containers/new/types/form";
import SidebarLayout from "./containers/sidebar-layout";
import SpeakerData from './containers/speaker-data';
import en from "./react-intl/locale-data/en";
import fr from "./react-intl/locale-data/fr";
import ErrorBoundary from "./components/ErrorBoundary";
import Actions from "./redux/actions";
import UnauthenticatedApp from './unauthenticated';
// import Test from "./components/TestDatas/Test";

const App = ({ dispatch, user }) => {
  // eslint-disable-next-line no-unused-vars
  const [locale, setLocale] = useState(localStorage.getItem("locale") || "fr");

  const getMessages = () => {
    switch (locale) {
      case "fr":
        return fr.messages;
      default:
        return en.messages;
    }
  };

  const _setLocale = (locale) => {
    localStorage.setItem("locale", locale);
    setLocale(locale);
    window.scrollTo(0, 0);
  };


  useEffect(() => {
    if (localStorage.getItem("token")) {
      dispatch(Actions.userProfile());
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      window.location.pathname !== "/account" &&
      user.profile.stripe_setup === false &&
      user.profile.free_user !== true &&
      moment().diff(moment(user.profile.created), "days") > 29
    ) {
      window.location.push("/account");
    }

  }, [user]);


  return (
    <div
      className="d-flex flex-column bg-ed justify-content-between"
      style={{ height: "100%" }}
    >
      <IntlProvider locale={locale} messages={getMessages()} key={locale}>
        <BrowserRouter onUpdate={() => window.scrollTo(0, 0)}>
          {user && user.email ? (
            <Authenticated user={user} locale={locale} setLocale={_setLocale} />
          ) : (
            <UnauthenticatedApp />
          )}
        </BrowserRouter>
      </IntlProvider>
    </div>
  );
};


const Authenticated = ({ user, locale, setLocale }) => {
  return (
    <SidebarLayout user={user} locale={locale} setLocale={setLocale}>
      <ReactQueryDevtools initialIsOpen={false} />
      <ReactQueryConfigProvider config={{
        refetchOnWindowFocus: false,
        queries: {
          staleTime: Infinity
        }
      }}>
        <Route render={({ location }) => (
          <ErrorBoundary locationKey={location.key}>
        <Switch>
          {/* <Route exact path="/" component={} /> */}
          <Route exact path="/" render={(props) => <Events locale={locale} setLocale={setLocale} {...props} />} />
          {/* <Route exact path="/" render={(props) => <Test locale={locale} setLocale={setLocale} {...props} />} /> */}
          <Route exact path="/event/add" render={(props) => <AddEvent locale={locale} setLocale={setLocale} {...props} />} />
x
          <Route exact path="/event/add/:name" render={(props) => <AddEvent locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/event/edit/:id" render={(props) => <AddEvent locale={locale} setLocale={setLocale} {...props} />} />

          <Route exact path="/manage-event/:id" render={(props) => <Presentations locale={locale} setLocale={setLocale} {...props} />} />
          <Route
            exact
            path="/manage-event/:event_id/add"
            render={(props) => <AddEditPresentation locale={locale} setLocale={setLocale} {...props} />}
          />
          <Route
            exact
            path="/manage-event/:event_id/add/:name"
            render={(props) => <AddEditPresentation locale={locale} setLocale={setLocale} {...props} />}
          />
          <Route
            exact
            path="/manage-event/:event_id/edit/:id"
            render={(props) => <AddEditPresentation locale={locale} setLocale={setLocale} {...props} />}
          />
          <Route exact path="/speakers"
            render={(props) => <Speakers locale={locale} setLocale={setLocale} {...props} />}
          />
          {/* Public views */}

          <Route exact path="/speakers/add"
            render={(props) => <AddSpeaker locale={locale} setLocale={setLocale} {...props} />}
          />
          <Route exact path="/speakers/add/:name" render={(props) => <AddSpeaker locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/speakers/edit/:id" render={(props) => <AddSpeaker locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/rooms" render={(props) => <Rooms locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/room/add" render={(props) => <AddRoom locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/room/add/:name" render={(props) => <AddRoom locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/room/edit/:id" render={(props) => <AddRoom locale={locale} setLocale={setLocale} {...props} />} />
          {/* <Route exact path="/schedule" component={Schedule} /> */}
          <Route exact path="/contact" render={(props) => <Contact locale={locale} setLocale={setLocale} {...props} />} />

          <Route exact path="/themes" render={(props) => <Themes locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/themes/add" render={(props) => <ThemeForm locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/themes/add/:name" render={(props) => <ThemeForm locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/themes/edit/:id" render={(props) => <ThemeForm locale={locale} setLocale={setLocale} {...props} />} />

          <Route exact path="/associations" render={(props) => <Associations locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/association/add" render={(props) => <AssociationForm locale={locale} setLocale={setLocale} {...props} />} />
          <Route
            exact
            path="/association/add/:name"
            render={(props) => <AssociationForm locale={locale} setLocale={setLocale} {...props} />}
          />
          <Route exact path="/association/edit/:id" render={(props) => <AssociationForm locale={locale} setLocale={setLocale} {...props} />} />

          <Route exact path="/types" render={(props) => <Types locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/type/add" render={(props) => <TypeForm locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/type/add/:name" render={(props) => <TypeForm locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/type/edit/:id" render={(props) => <TypeForm locale={locale} setLocale={setLocale} {...props} />} />

          <Route exact path="/sessions" render={(props) => <Sessions locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/session/add" render={(props) => <SessionForm locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/session/add/:name" render={(props) => <SessionForm locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/session/edit/:id" render={(props) => <SessionForm locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/manage-presentations/:event_id/:speaker_id" render={(props) => <UploadPresentation locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/manage-videos/:event_id/:speaker_id" render={(props) => <UploadVideo locale={locale} setLocale={setLocale} {...props} />} />
          <Route exact path="/speaker-data/:event_id/:speaker_id/:module" render={(props) => <SpeakerData locale={locale} setLocale={setLocale} {...props} />} />
        </Switch>
          </ErrorBoundary>
        )} />
      </ReactQueryConfigProvider>
    </SidebarLayout>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(App);
